import { Link as RouterLink } from "react-router-dom";
import { ListItemButton, ListItemText } from "@mui/material";
import ArrowIcon from "@mui/icons-material/ArrowForwardIos";
import { BookingListing } from "api/users/getMyBookings";
import OutlinedCard from "components/OutlinedCard";
import { formatTime } from "utilities/formatTime";

type BookingItemProps = {
  booking: BookingListing;
};

const BookingItem: React.FC<BookingItemProps> = (props) => {
  const { booking } = props;

  const startTime = formatTime(new Date(booking.startTime));
  const endTime = formatTime(new Date(booking.endTime));

  return (
    <OutlinedCard key={booking.id} sx={{ p: 0 }}>
      <ListItemButton component={RouterLink} to={`/orders/view/${booking.orderNumber}`}>
        <ListItemText primary={booking.title} secondary={`${startTime} - ${endTime}`} />
        <ArrowIcon sx={{ opacity: 0.5 }} />
      </ListItemButton>
    </OutlinedCard>
  );
};

export default BookingItem;
